import { render, staticRenderFns } from "./ScoringDefinitionDistributionChart.vue?vue&type=template&id=376c9213&scoped=true"
import script from "./ScoringDefinitionDistributionChart.vue?vue&type=script&lang=js"
export * from "./ScoringDefinitionDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c9213",
  null
  
)

export default component.exports